import React from "react";
import { Routes, Route } from 'react-router-dom';
import { About } from "./components/scene/about";
import { Account } from "./components/scene/account";
import { AccountInfo } from "./components/scene/accountinfo";
import { Address } from "./components/scene/address";
import { Cart } from "./components/scene/cart";
import { Checkout } from "./components/scene/checkout";
import { Contact } from "./components/scene/contact";
import { Error } from "./components/scene/Error";
import { Faq } from "./components/scene/faq";
import Home from "./components/scene/home";
import { Lens } from "./components/scene/lens";
import { Login } from "./components/scene/login";
import { Payment } from "./components/scene/payment";
import { Prescriptions } from "./components/scene/prescriptions";
import { PrivacyPolicy } from "./components/scene/privacyPolicy";
import { Productdetail } from "./components/scene/productdetail";
import { ReturnsExchanges } from "./components/scene/returnsExchanges";
import { Shipping } from "./components/scene/shipping";
import { ShippingDelivery } from "./components/scene/shippingDelivery";
import { Signup } from "./components/scene/signup";
import { Store } from "./components/scene/store";
import { TermsConditions } from "./components/scene/termsConditions";
import { ThankYou } from "./components/scene/thankyou";

const App = () => {
  return (
      <Routes>
        <Route exact path='/' element={<Home />} />
          <Route exact path='/store' element={<Store />} />
          <Route exact path='/productdetail' element={<Productdetail />} />
          <Route exact path='/checkout' element={<Checkout />} />
          <Route exact path='/shipping' element={<Shipping />} />
          <Route exact path='/payment' element={<Payment />} />
          <Route exact path='/thankyou' element={<ThankYou />} />
          <Route exact path='/login' element={<Login />} />
          <Route exact path='/signup' element={<Signup />} />
          <Route exact path='/account' element={<Account />} />
          <Route exact path='/editaccount' element={<AccountInfo />} />
          <Route exact path='/address' element={<Address />} />
          <Route exact path='/prescriptions' element={<Prescriptions />} />
          <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route exact path='/terms-conditions' element={<TermsConditions />} />
          <Route exact path='/returns-exchanges' element={<ReturnsExchanges />} />
          <Route exact path='/contact-us' element={<Contact />} />
          <Route exact path='/shipping-delivery' element={<ShippingDelivery />} />
          <Route exact path='/faq' element={<Faq />} />
          <Route exact path='/about-us' element={<About />} />
          <Route exact path='/lens' element={<Lens />} />
          <Route exact path='/cart' element={<Cart />} />
          <Route path="*" element={<Error />} />
      </Routes>
  );
};

export default App;